var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSparkle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 25,
    viewBox: "0 0 21 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2834 0.859531C10.3694 7.14963 6.00201 12.3291 0.53069 12.4289C6.00241 12.3291 10.5094 17.3494 10.5958 23.6405C10.5094 17.3494 14.8757 12.169 20.3486 12.0693C14.8756 12.1699 10.3694 7.14963 10.2834 0.859531Z",
    fill: "#2248C1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2373 1.58077C16.2713 4.06197 14.5485 6.10504 12.3903 6.14443C14.5487 6.10505 16.3265 8.08539 16.3606 10.567C16.3265 8.08539 18.0488 6.04191 20.2077 6.00257C18.0488 6.04227 16.2713 4.06197 16.2373 1.58077Z",
    fill: "#2248C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkle);
export default __webpack_public_path__ + "static/media/sparkle.da7e3d3b51f4e30990630f5a9dc9245e.svg";
export { ForwardRef as ReactComponent };